import { render, staticRenderFns } from "./AppointmentModal.vue?vue&type=template&id=1508d83a&scoped=true&"
import script from "./AppointmentModal.vue?vue&type=script&lang=js&"
export * from "./AppointmentModal.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AppointmentModal.vue?vue&type=style&index=1&id=1508d83a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1508d83a",
  null
  
)

export default component.exports